var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceCeter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service_Ceter",
    "data-name": "Service Ceter",
    transform: "translate(-85 -916.458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    width: 32,
    height: 32,
    transform: "translate(85 916.458)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings-input-hdmi",
    "data-name": "Icon material-settings-input-hdmi",
    d: "M5.37,2.065V.826A.829.829,0,0,0,4.544,0h-3.3A.829.829,0,0,0,.413.826V2.065H0V4.544L1.239,7.022V8.262h3.3V7.022L5.783,4.544V2.065ZM1.239.826h3.3V2.065H3.718V1.239H3.3v.826H2.479V1.239H2.065v.826H1.239Z",
    transform: "translate(101.413 925.549) rotate(45)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings-cell",
    "data-name": "Icon material-settings-cell",
    d: "M10.106,26.546h2.212V24.334H10.106Zm4.424,0h2.212V24.334H14.53Zm4.424,0h2.212V24.334H18.955ZM20.061.011,11.212,0A2.219,2.219,0,0,0,9,2.212v17.7a2.219,2.219,0,0,0,2.212,2.212h8.849a2.219,2.219,0,0,0,2.212-2.212V2.212a2.209,2.209,0,0,0-2.212-2.2Zm.737,19.9H10.475V2.95H20.8Z",
    transform: "translate(84.9 918.913)",
    fill: "#fff",
    opacity: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCeter);
export default __webpack_public_path__ + "static/media/service-ceter.186f7b0870ffc1433b4baa4eaac1f2c8.svg";
export { ForwardRef as ReactComponent };